const zh = {
  navbar: {
    title: 'AI听说训练',
    library: '素材库',
    product: '场景',
    workflow: '使用方式',
    pricing: '定价',
    resources: 'FAQ',
    login: '登录',
    signup: '免费开始',
    logout: '退出'
  },
  userMenu: {
    profile: '学习偏好',
    manageBilling: '管理 / 取消订阅',
    openMenu: '打开账户菜单',
    account: '我的账户',
    monthlyBalance: '本月额度',
    permanentBalance: '永久额度',
    upgradeTitle: '升级套餐',
    upgradeDescription: '获得更多字幕与语音额度',
    buyCreditsTitle: '购买永久额度',
    inviteTitle: '邀请有礼',
    redeemGiftCode: '兑换礼品码',
    tutorial: '使用教程',
    feedback: '意见反馈'
  },
  referral: {
    title: '邀请有礼',
    partnerNote: '你是推广伙伴，邀请用户拿现金分成，不再发放下面的点数奖励。',
    partnerLink: '去推广中心',
    codeLabel: '我的邀请码',
    linkLabel: '邀请链接',
    copyCode: '复制邀请码',
    copyLink: '复制链接',
    copied: '已复制',
    copyFailed: '复制失败，请手动选择复制',
    statRewarded: '成功邀请 {count} 人',
    statEarned: '累计获得 {amount} 额度',
    referredBy: '邀请人 {email}',
    trackSignup: '好友注册',
    trackSignupDesc: '通过你的链接或邀请码',
    trackActivate: '开始使用',
    trackActivateDesc: '验证邮箱，累计用掉 {threshold} 额度',
    trackActivateReward: '你 +{reward}　好友 +{inviteeReward}',
    trackConvert: '首次付费',
    trackConvertDesc: '订阅或购买额度包',
    trackConvertReward: '你 +{reward}',
    progressUsed: '已用 {used} / {threshold}',
    monthlyLimitNote: '使用奖励每月最多 {limit} 次，本月已得 {count} 次；超出后好友照常得额度，你这次不拿。首次付费奖励不受此限制。',
    listTitle: '邀请记录',
    listEmpty: '还没有人用你的邀请码注册。把链接发给一起学英语的朋友吧。',
    statusBound: '已注册',
    statusActivated: '已开始使用',
    statusConverted: '已付费',
    capped: '本月已达上限',
    bindTitle: '填写邀请码',
    bindHint: '注册 {days} 天内可以补填一次，填写后不能修改。',
    bindPlaceholder: '6 位邀请码',
    bindButton: '确认填写',
    bindSuccess: '邀请码已填写，开始使用后即可获得奖励',
    signupCodeLabel: '邀请码（选填）',
    signupCodePlaceholder: '有邀请码就填在这里',
    invalidCode: '邀请码不存在，请检查后重试',
    loadFailed: '邀请信息加载失败',
    retry: '重试',
    errors: {
      invalid: '邀请码不存在，请检查后重试',
      self: '不能填写自己的邀请码',
      already_bound: '你已经填写过邀请码',
      too_old: '注册已超过 7 天，不能再填写邀请码'
    },
    share: {
      title: '发帖分享，领永久额度',
      summary: '最低 +{reward} 额度，每个点赞收藏再 +{per}',
      statusApproved: '已发放',
      approvedText: '感谢分享，{reward} 永久额度已到账',
      statusPending: '审核中',
      pendingText: '{date} 提交，审核时按点赞收藏数发放，通过后自动到账',
      rejected: '上次提交未通过，可以换个帖子重新提交',
      rejectedWithReason: '上次提交未通过：{reason}',
      urlPlaceholder: '粘贴帖子链接',
      submit: '提交审核',
      submitted: '已提交，我们会尽快审核',
      kitCopyLabel: '参考文案',
      kitNext: '换一条',
      kitCopy: '复制文案',
      kitNote: '照抄容易被平台判成重复内容，建议改成自己的话，再配一张你自己的练习截图。',
      kitImagesLabel: '配图（点击保存）',
      kitSaveImage: '保存图片',
      stepPost: '发一篇使用笔记',
      stepPostDesc: '小红书、抖音、TikTok 等都可以，图文或视频均可，聊聊你的使用感受',
      stepKeep: '发帖 {days} 天后再提交',
      stepKeepDesc: '帖子要一直公开，等点赞收藏攒一攒再来，提交后很快就能审核通过',
      stepSubmit: '提交链接领额度',
      stepReward: '+{reward} ~ +∞',
      rangeFrom: '起',
      rangeLabel: '奖励 {reward} 额度起，上不封顶',
      stepSubmitDesc: '保底 {reward}，每个点赞或收藏再加 {per}，每个账号可领一次',
      platforms: {
        xiaohongshu: '小红书',
        douyin: '抖音',
        tiktok: 'TikTok',
        instagram: 'Instagram',
        youtube: 'YouTube',
        x: 'X（Twitter）',
        other: '其他'
      },
      errors: {
        invalid_url: '没有识别到链接，请在帖子里点分享，复制链接后粘贴过来',
        pending: '你已有一条在审核中的提交',
        already_rewarded: '这个账号已经领过分享奖励'
      }
    },
    gift: {
      title: '兑换礼品码',
      placeholder: '8 位礼品码',
      button: '兑换',
      hint: '兑换为永久额度，每个码每个账号只能用一次。',
      success: '兑换成功，{credits} 永久额度已到账',
      errors: {
        invalid: '礼品码不存在，请检查后重试',
        disabled: '这个礼品码已失效',
        used_up: '这个礼品码已被领完',
        already_redeemed: '你已经兑换过这个礼品码'
      }
    },
    rewardAdmin: {
      tab: '分享与礼品码',
      shareTitle: '分享审核',
      filterPending: '待审核',
      filterAll: '全部',
      user: '用户',
      platform: '平台',
      post: '帖子',
      submittedAt: '提交时间',
      status: '状态',
      action: '操作',
      reward: '额度',
      engagement: '点赞+收藏',
      engagementShort: '赞藏 {count}',
      approve: '通过',
      reject: '驳回',
      rejectPrompt: '驳回原因（会展示给用户，可留空）',
      statusPending: '待审核',
      statusApproved: '已通过',
      statusRejected: '已驳回',
      shareEmpty: '没有提交记录',
      codesTitle: '礼品码',
      credits: '每码额度',
      count: '生成数量',
      maxRedemptions: '每码可兑换次数',
      note: '备注（如活动名）',
      generate: '生成',
      generated: '已生成 {count} 个礼品码',
      copyAll: '复制本次生成的码',
      code: '礼品码',
      used: '已兑换',
      createdAt: '生成时间',
      viewRedemptions: '查看兑换人',
      disable: '停用',
      enable: '恢复',
      disabled: '已停用',
      codesEmpty: '还没有礼品码',
      redemptionsEmpty: '还没有人兑换'
    },
    admin: {
      tab: '邀请记录',
      filterPlaceholder: '按邀请人邮箱筛选',
      search: '筛选',
      clear: '清除',
      empty: '没有邀请记录',
      referrer: '邀请人',
      invitee: '被邀请人',
      status: '状态',
      used: '已用额度',
      boundAt: '绑定时间',
      rewards: '发放额度',
      inviteeReward: '被邀请人',
      referrerReward: '邀请人',
      conversionReward: '付费奖励',
      cappedShort: '已封顶',
      total: '共 {count} 条'
    }
  },
  partner: {
    eyebrow: 'GoodScriber 推广伙伴',
    title: '推荐 GoodScriber，拿分成',
    subtitle: '适合英语博主、老师和学习社群。审核通过后，你会拿到专属邀请码和自己的推广中心。',
    centerTitle: '推广中心',
    centerSubtitle: '你的邀请码、邀请的用户和佣金都在这里。',
    benefits: {
      commission: { title: '现金分成', desc: '粉丝用你的邀请码注册并付费，你按成交拿分成，续费也算。' },
      premium: { title: '免费 Premium 会员', desc: '审核通过就送，先自己用熟，再推荐给别人。' },
      audience: { title: '粉丝专属优惠', desc: '用你的码注册的人，首次购买享受比普通用户更大的折扣。' }
    },
    stepsTitle: '怎么合作',
    steps: {
      apply: { title: '填写申请', desc: '留下称呼、主页和联系方式，一分钟就能填完。' },
      share: { title: '拿到专属邀请码', desc: '审核通过后开通推广中心，把邀请码或链接分享给粉丝。' },
      earn: { title: '按成交拿分成', desc: '粉丝付费后佣金自动记账，每月结算一次。' }
    },
    rulesTitle: '合作规则',
    rules: {
      commission: { title: '{rate}% 现金分成', desc: '用你的码注册的用户付费后，按我们实际到账金额（扣除支付手续费后）的 {rate}% 给你分成。' },
      duration: { title: '每位用户分成 {months} 个月', desc: '从用户第一次付费起算 {months} 个月，期间的续费和再次购买都算。' },
      fans: { title: '粉丝福利', desc: '用你的码注册的用户激活后送 500 点，首次购买比普通用户多减 20 个百分点。' },
      settlement: { title: '{days} 天后可提现', desc: '付款满 {days} 天转为可提现，每月按可提现金额全额打款到你的收款账号。' },
      refund: { title: '退款和拒付', desc: '用户退款或拒付时，对应的佣金会从下一次打款里扣回。' }
    },
    loginHint: '登录或注册后就能填写申请。',
    loginButton: '登录后申请',
    loadFailed: '加载失败：{error}',
    retry: '重新加载',
    status: {
      pending: '审核中',
      rejected: '未通过',
      disabled: '已暂停'
    },
    pendingTitle: '申请已提交',
    pendingDesc: '你在 {date} 提交了申请。审核通过后，这个页面会变成你的推广中心。',
    rejectedDesc: '这次申请没有通过，可以修改后重新提交。',
    disabledDesc: '你的推广已暂停，新的付款暂不计佣金。已产生的佣金照常结算。',
    form: {
      title: '申请成为推广伙伴',
      name: '称呼',
      namePlaceholder: '怎么称呼你',
      profileUrl: '主页链接',
      profileUrlPlaceholder: '小红书、B 站、YouTube 等主页链接',
      contact: '联系方式',
      contactPlaceholder: '微信号或邮箱',
      submit: '提交申请',
      note: '提交后我们会尽快审核，结果会显示在这个页面。',
      failed: '提交失败：{error}'
    },
    codeLabel: '邀请码',
    linkLabel: '邀请链接',
    copyCode: '复制邀请码',
    copyLink: '复制链接',
    copied: '已复制',
    copyFailed: '复制失败，请手动选中复制',
    premiumUntil: '你的 Premium 有效期至 {date}。',
    premiumPaidPlan: '你已经是付费会员，赠送的 Premium 没有覆盖你的订阅。',
    premiumEnded: '赠送的 Premium 已结束。',
    stats: {
      invitees: '邀请人数',
      paidInvitees: '付费人数',
      pending: '待确认',
      available: '可提现',
      paid: '已打款'
    },
    invitees: {
      title: '邀请的用户',
      user: '用户',
      boundAt: '注册时间',
      status: '状态',
      netAmount: '累计到账',
      commission: '佣金',
      endsAt: '分成截止',
      empty: '还没有人用你的码注册。'
    },
    inviteeStatus: {
      bound: '已注册',
      activated: '已激活',
      converted: '已付费',
      paid: '已付费'
    },
    commissions: {
      title: '佣金明细',
      date: '时间',
      user: '用户',
      kind: '类型',
      netAmount: '到账金额',
      commission: '佣金',
      status: '状态',
      availableAt: '可提现日期',
      empty: '还没有佣金记录。'
    },
    commissionKind: {
      payment: '付款',
      refund: '退款扣回',
      dispute: '拒付扣回'
    },
    commissionStatus: {
      pending: '待确认',
      available: '可提现',
      paid: '已打款'
    },
    payouts: {
      title: '打款记录',
      date: '时间',
      amount: '金额',
      method: '方式',
      note: '备注'
    },
    payoutInfo: {
      title: '收款信息',
      desc: '每月结算时按这里的信息打款。',
      method: '收款方式',
      methodPlaceholder: '例如 支付宝、PayPal、微信',
      account: '收款账号',
      accountName: '收款人姓名',
      save: '保存收款信息',
      saved: '收款信息已保存',
      failed: '保存失败：{error}'
    }
  },
  partnerAdmin: {
    title: '推广伙伴管理',
    signedInAs: '当前管理员：{email}',
    refresh: '刷新',
    loginHint: '用管理员账号登录后查看。',
    login: '登录',
    forbidden: '这个账号没有管理权限。',
    loadFailed: '加载失败：{error}',
    actionFailed: '操作失败：{error}',
    filterLabel: '按状态筛选',
    tabs: {
      pending: '待审核',
      approved: '已通过',
      disabled: '已停用',
      rejected: '已拒绝',
      all: '全部'
    },
    status: {
      pending: '待审核',
      approved: '已通过',
      disabled: '已停用',
      rejected: '已拒绝'
    },
    columns: {
      partner: '伙伴',
      contact: '联系方式',
      status: '状态',
      rate: '比例',
      invitees: '邀请人数',
      netAmount: '到账金额',
      pending: '待确认',
      available: '可提现',
      paid: '已打款',
      appliedAt: '申请时间'
    },
    empty: '这里还没有伙伴。',
    code: '邀请码',
    application: '申请信息',
    appliedAt: '申请时间',
    payoutInfo: '收款信息',
    payoutMethod: '收款方式',
    payoutAccount: '收款账号',
    payoutAccountName: '收款人',
    review: '审核',
    reviewHint: '通过后自动生成邀请码，并送 3 个月 Premium。',
    rejectNotePlaceholder: '拒绝原因（选填，伙伴能看到）',
    approve: '通过',
    reject: '拒绝',
    payout: '打款',
    payoutHint: '当前可提现 {amount}，打款后点下面的按钮记账。',
    payoutMethodPlaceholder: '打款方式，例如 支付宝',
    payoutNotePlaceholder: '备注，例如 转账单号',
    markPaid: '标记已打款 {amount}',
    terms: '分成条件',
    ratePercent: '分成比例（%）',
    months: '分成月数',
    saveTerms: '保存分成条件',
    premium: '赠送 Premium',
    premiumUntil: '赠送的 Premium 有效期至 {date}。',
    premiumPaidPlan: '对方是付费会员（到期 {date}），没有覆盖。',
    premiumNone: '当前方案：{plan}。',
    premiumMonths: '延长月数',
    extendPremium: '延长 Premium',
    revokePremium: '收回 Premium',
    account: '伙伴状态',
    disable: '停用伙伴',
    enable: '重新启用',
    paidInvitees: '付费人数',
    invitees: '邀请的用户',
    user: '用户',
    boundAt: '注册时间',
    firstPaidAt: '首次付费',
    commission: '佣金',
    endsAt: '分成截止',
    noInvitees: '还没有邀请到用户。',
    commissions: '佣金明细',
    paidAt: '时间',
    kind: '类型',
    purchaseType: '购买',
    purchase: {
      subscription: '订阅',
      credits: '点数包'
    },
    noCommissions: '还没有佣金记录。',
    payouts: '打款记录',
    amount: '金额',
    note: '备注',
    commissionCount: '笔数'
  },
  creation: {
    title: '创建练习材料',
    balance: '可用额度',
    buy: '购买额度',
    loginHint: '登录后才能生成并保存。',
    intro: {
      youtube: '粘贴 YouTube 链接，导入视频并生成字幕。',
      transcribe: '上传一段音频或视频，生成可以逐句播放和跟读的字幕。',
      speech: '输入文稿并选择声音，生成自己的听力和跟读材料。'
    }
  },
  sidebar: {
    Profile: '学习偏好',
    workspace: '练习区',
    create: '创作工具',
    Shortcut: '快捷导航',
    RecentFiles: '最近文件',
    Transcribe: '生成字幕',
    YouTubeImport: '导入 YouTube',
    TextToSpeech: '生成语音',
    Home: '主页',
    Material: '听读素材',
    CheckIn: '打卡',
    LearningRecords: '跟读记录',
    VocabularyBook: '学习本',
    Referral: '邀请有礼'
  },
  home: {
    welcome: 'GoodScriber',
    kicker: 'AI听说训练',
    heroTitle: '智能跟读\n练习听说',
    subtitle: '把任意音频变成单词级字幕\n再按句精听 跟读 评分',
    startButton: '开始练习',
    loginToStart: '免费开始',
    tryDemo: '试用',
    faqLink: '查看常见问题',
    heroDescription: '上传音视频或粘贴 YouTube 链接，GoodScriber 自动分句、逐句播放，录下你的跟读并给出发音评分。',
    desktopRecommendNotice: '手机上可以随时听和练；逐句跟读、看评分和查词，建议用电脑打开，体验更好。',
    gifCaptions: {
      leftTop: '海量听说练习材料',
      leftBottom: '高效提升听说能力',
      rightTop: '上传音频或输入文本',
      rightBottom: '快速生成字幕和语音'
    },
    workflow: {
      title: '三步开始跟读',
      subtitle: '从选素材到看评分，每一步都在同一个练习区里完成。',
      steps: {
        library: {
          title: '选一段素材',
          description: '从素材库挑一条感兴趣的视频或音频，也可以上传自己的文件、粘贴 YouTube 链接。',
          alt: '素材库中的两个分类：YouTube Vlog 沉浸（视频）和 IELTS Listening（音频）'
        },
        repeat: {
          title: '逐句听，跟着说',
          description: '每播完一句就停下来等你开口。智能跟读会听你说完再继续，定时跟读按固定停顿推进。',
          alt: '跟读中的当前句，正在播放的单词高亮；下方跟读栏显示智能跟读模式，提示开口'
        },
        score: {
          title: '看评分，改问题词',
          description: '说完马上看到总分、准确度、完整度和流利度，点开问题词对比原音，再说一遍。',
          alt: '真实发音评分结果：总分 88，准确度 89，完整度 83，流利度 100，问题词 Many'
        }
      }
    },
    highlights: {
      ranking: '语音转文字',
      tts: '自然语音生成',
      practice: '智能跟读和练习',
      accuracy: '99.8% 准确率',
      security: '隐私安全'
    },
    featuresTitle: '支持多语言听说的学习工具',
    scenario: {
      title: '适合这些练习',
      subtitle: '不同目标，从不同入口开始。',
      items: {
        ielts: {
          title: '雅思听说',
          description: '用雅思听力原题逐句精听、跟读，熟悉考试语速和常见表达。',
          action: '打开雅思素材'
        },
        vlog: {
          title: '看 YouTube 学口语',
          description: '跟着博主的日常 Vlog 练自然语速和生活表达。',
          action: '打开生活 Vlog'
        },
        interview: {
          title: '面试和演讲',
          description: '粘贴自己的稿子生成自然语音，再逐句跟读到开口不卡。',
          action: '用自己的稿子练'
        },
        pronunciation: {
          title: '发音矫正',
          description: '每句都有发音评分和问题词提示，对比原音反复练。',
          action: '体验评分演示'
        }
      }
    },
    faqTitle: '常见问题',
    faqSubtitle: '了解更多关于GoodScriber的信息',
    faq: [
      {
        question: '什么是跟读练习？',
        answer: '跟读练习是先听一小段示范，再模仿其中的词、重音、节奏和停顿。GoodScriber 可以把材料按句拆开，支持单句回放、录音和练习反馈。实际效果会受到学习者水平、材料难度和练习质量影响。'
      },
      {
        question: '如何使用文字转语音功能准备雅思口语？',
        answer: '粘贴自己的雅思口语答案，生成示范语音，再逐句练习。重点观察停顿、重音和语速。GoodScriber 的反馈只用于日常练习，不代表官方雅思分数，也不用于预测分数。'
      },
      {
        question: '为什么音频转文字对语言学习很重要？',
        answer: '音频转文字能把难以定位的声音变成可搜索、可回放的句子。建议先听，再用转写定位漏听内容，检查重要识别错误，最后重复听和跟读难句。转写文本本身不会自动带来听力提升。'
      },
      {
        question: 'GoodScriber支持哪些语言？',
        answer: 'GoodScriber 支持多语言转写、字幕翻译和文字转语音。不同功能和处理服务支持的语言范围不同，处理长文件前请先查看对应工具中的语言选择器。'
      },
      {
        question: '我可以翻译转录和字幕吗？',
        answer: '可以。GoodScriber 支持字幕翻译与对照学习，方便你理解原文表达并进行多语言学习。'
      },
      {
        question: '什么是GoodScriber？',
        answer: 'GoodScriber 是面向语言学习者的听说练习区。它把本地音频、视频或口语稿变成可编辑字幕或练习语音，再支持逐句回放、录音、反馈和复习。'
      },
      {
        question: '费用是多少？',
        answer: 'GoodScriber提供免费和付费计划。免费计划每月包含200点数；如果全部用于单项功能，约可转录20分钟、进行6分钟发音评分，或用多语言声音库生成3,000字符、用自然人声生成6,000字符。专业版提供5,000点数（约500分钟转录），高级版提供10,000点数（约1,000分钟转录）。转录、语音合成和发音评分共享月度额度。具体价格请查看价格页面。'
      },
      {
        question: 'GoodScriber安全吗？',
        answer: 'GoodScriber 使用 Firebase 和 Google Cloud 基础设施处理账户数据与文件存储。转写、语音生成、支付和分析可能涉及隐私政策列出的 OpenAI、Google Cloud、Stripe 和 Google Analytics 等服务商。你可以在服务中删除已上传文件。'
      },
      {
        question: '我可以导出我的转录文件吗？',
        answer: '当然可以。GoodScriber支持多种导出格式，包括纯文本、SRT字幕文件、Word文档等。您可以轻松下载并在其他应用程序中使用这些文件，方便集成到您的学习或工作流程中。'
      },
      {
        question: '我可以导出我的音频文件吗？',
        answer: '是的，GoodScriber允许您下载通过文字转语音生成的所有音频文件。您可以将这些文件用于离线学习、创建播客、制作视频或任何其他用途。所有下载的音频都是高质量的MP3格式。'
      },
      {
        question: '我可以转换多少语音？',
        answer: '转换额度取决于您的账户类型。免费账户每月可获得200点数；如果全部用于单项功能，约相当于20分钟音频转录、6分钟发音评分，或多语言声音库 3,000字符/自然人声 6,000字符。专业版提供5,000点数（约500分钟转录），高级版提供10,000点数（约1,000分钟转录）。转录、语音合成和发音评分共享月度额度，未使用的点数不会累积到下个月。'
      },
      {
        question: '如何取消我的订阅？',
        answer: 'Pro 和 Premium 订阅会按月或按年自动续费，直到您取消。您可以在账户菜单中选择“管理订阅”，通过 Stripe 取消。取消会在当前已付费周期结束后生效。单买额度不会续费，并且永久有效。'
      }
    ],
    statsTitle: '语言学习者的选择',
    stats: {
      title: '全球用户的信赖之选',
      accuracy: '准确率',
      bilingualValue: '57种',
      bilingual: '多语言转写',
      users: '活跃用户',
      hoursTranscribed: '转录时长',
      charactersGenerated: '字符生成语音'
    },
    heroShot: {
      aria: '打开截图中的演示',
      alt: 'GoodScriber 练习区：左侧视频，右侧双语字幕，当前单词高亮，正在等待你跟读',
      action: '试用'
    },
    library: {
      title: '真实英语素材',
      subtitle: 'YouTube 博主 Vlog、雅思真题、播客和 TED-Ed，字幕都已按句切好。挑一条感兴趣的，直接开始逐句跟读。',
      vlogMedia: '视频 · YouTube',
      vlogTitle: '生活 Vlog',
      vlogDescription: '跟着真实博主的日常学口语：语速自然，话题贴近生活，听到的就是母语者每天在说的英语。',
      vlogPoints: [
        '按博主整理成合集，连续跟一个人的口音和表达',
        '每条视频标好时长和难度，挑适合自己的开始',
        '左边看视频，右边逐句跟读、录音、看发音评分'
      ],
      vlogAction: '进入生活 Vlog',
      vlogShotAlt: '生活 Vlog 分类：左侧是博主合集，右侧是带时长和难度标签的视频素材',
      moreTitle: '更多素材分类',
      browseAll: '浏览全部素材',
      video: '视频',
      audio: '音频'
    },
    ctaTitle: '立即提升语言水平',
    cta: {
      title: '立即体验GoodScriber',
      subtitle: '高效跟读与自然语音，支持多语言听说训练',
      supportLabel: '客服邮箱： ',
      notes: ['自带示例音频', '上传素材即可练', '逐句跟读反馈']
    },
    partnerBand: {
      title: '做英语内容或在教英语？',
      desc: '成为推广伙伴，把 GoodScriber 推荐给你的粉丝或学生，按成交拿分成，还送 Premium 会员。',
      action: '成为推广伙伴'
    },
    footer: {
      description: '为每一个想要练好口语和听力的人打造的 AI 跟读工具。',
      product: '产品',
      scenarios: '应用场景',
      workflow: '使用方式',
      pricing: '定价',
      demoAudio: '在线试用',
      feedback: '意见反馈',
      resources: '资源',
      faq: '常见问题',
      legal: '法律',
      copyright: '© 2026 GoodScriber. 保留所有权利。',
      tagline: '为全世界的口语练习者而造。'
    },
    toolsTitle: '工具',
    tools: {
      title: '工具',
      list: [
        '跟读网站', '英语跟读', '跟读练习', '跟读软件', '英语口语网站', '英语学习网站', '英语听力网站',
        '免费文字转语音', '文字转语音', '文字转语音软件', '文字转语音网站', '文字转语音工具',
        '免费音频转文字', '视频生成字幕', '音频转文字', '视频转文字', '文字转字幕', '音频转Word', 'MP3转文本', 'MP4转文本', 'MP3转字幕', 'MP4转字幕', '录音转文字',
        '雅思听力练习', '雅思口语练习', '托福口语练习', '托福听力练习', '听力打卡', '口语打卡',
        '英文文字转语音', '中文文字转语音', '多语言音频转文字', '多语言字幕生成',
        '字幕翻译', '英语精听', '英语跟读', '中文普通话练习'
      ]
    },
    pricing: {
      title: '价格',
      free: {
        label: '轻量体验',
        title: '免费版',
        credits: '额度 200 / 月',
        pronunciation: '发音评分 约 6 分钟 / 月',
        transcription: '转录时长 20 分钟 / 月',
        tts: '语音合成 最高 6,000 字符 / 月'
      },
      pro: {
        label: '最受欢迎',
        title: 'Pro版',
        credits: '额度 5,000 / 月',
        pronunciation: '发音评分 约 167 分钟 / 月',
        transcription: '转录时长 500 分钟 / 月',
        tts: '语音合成 最高 150,000 字符 / 月'
      },
      premium: {
        label: '深度学习',
        title: 'Premium版',
        credits: '额度 10,000 / 月',
        pronunciation: '发音评分 约 333 分钟 / 月',
        transcription: '转录时长 1,000 分钟 / 月',
        tts: '语音合成 最高 300,000 字符 / 月'
      },
      allowanceNote: '发音评分、转录和语音合成的上限，均按全部月度额度用于该单项功能计算，三项共享额度。'
    }
  },
  recentFiles: {
    workspace: '练习区',
    subtitle: '集中管理你的字幕与语音项目',
    fileCount: '{count} 个项目',
    refresh: '刷新',
    title: '最近文件',
    name: '名称',
    uploadedTime: '上传时间',
    duration: '时长',
    type: '类型',
    status: '状态',
    actions: '操作',
    transcribe: '生成字幕',
    textToSpeech: '生成语音',
    youtubeImport: '导入 YouTube',
    noFiles: '暂无记录',
    loading: '加载中...',
    opening: '打开中...',
    loadMore: '加载更多',
    loadingMore: '加载中...',
    noMoreFiles: '没有更多记录了',
    retry: '重试',
    typeSTT: '音频转字幕',
    typeTTS: '文字转语音',
    typeTTSSTT: '文字转字幕',
    typeYouTube: 'YouTube 字幕',
    tokenBalance: '余额：',
    premiumUser: '高级用户',
    proUser: '专业用户',
    freeUser: '免费用户',
    lowUsageWarning: '余额较低，建议升级到高级版',
    usageExceeded: '余额不足，请升级到高级版',
    upgrade: '升级',
    rename: '重命名',
    delete: '删除',
    processing: '处理中',
    completed: '已完成',
    pending: '等待中',
    error: '失败',
    dialog: {
      rename: {
        title: '重命名文件',
        placeholder: '请输入新的文件名',
        confirm: '确认',
        cancel: '取消'
      },
      delete: {
        title: '删除文件',
        message: '确定要删除这个文件吗？',
        warning: '此操作无法撤销。',
        confirm: '删除',
        cancel: '取消'
      }
    }
  },
  audioUploader: {
    subtitle: '上传素材后自动生成可编辑字幕，适合精听和跟读。',
    title: '语音转字幕',
    clickText: '上传音频或视频',
    dragText: '拖拽音频文件到这里，或点击选择文件',
    supportedFormats: '拖拽到这里，或点击选择文件',
    invalidFile: '不支持的文件格式',
    durationLimit: '单个文件最长 {maxDuration} 分钟',
    converting: '正在转换文件...',
    uploading: '正在上传...',
    uploadNextStep: '上传完成后将自动开始生成字幕',
    generatingSubtitles: '正在生成字幕',
    processing: '正在处理...',
    fileTooLarge: '文件大小不能超过{maxSize}',
    usageCost: '消耗：{cost}额度',
    insufficientUsage: '剩余额度不足',
    providerLabel: '识别方式',
    providerHint: '单一语言素材用精准识别；中英混合等多语言素材用多语言识别。',
    providers: {
      deepgram: '精准识别',
      openai: '多语言识别'
    },
    languageLabel: '素材语言',
    languageHint: '单语言素材选择对应语言，多语言素材选择自动识别。',
    languages: {
      english: '英语',
      auto: '自动检测',
      chinese: '中文',
      japanese: '日语',
      korean: '韩语',
      french: '法语',
      german: '德语',
      spanish: '西班牙语',
      italian: '意大利语',
      portuguese: '葡萄牙语',
      russian: '俄语',
      hindi: '印地语',
      arabic: '阿拉伯语'
    },
    smartSentences: '智能分句',
    smartSentencesHint: '智能地将片段组合成完整句子'
  },
  youtubeImporter: {
    title: '导入 YouTube 视频',
    subtitle: '粘贴公开视频链接，我们生成逐句字幕并保存到练习区。',
    urlLabel: 'YouTube 视频地址',
    urlPlaceholder: 'https://www.youtube.com/watch?v=...',
    pasteFailed: '无法读取剪贴板，请检查浏览器权限。',
    inspect: '检查视频',
    inspecting: '正在检查...',
    duration: '视频时长',
    usage: '预计消耗',
    planLimit: '单条上限',
    credits: '{count} 额度',
    minutes: '{count} 分钟',
    insufficient: '需要 {count} 额度，当前余额只有 {balance}。',
    create: '导入并生成字幕',
    preparing: '正在创建任务...'
  },
  audioPlayer: {
    workspace: '练习区',
    playVideo: '播放视频',
    playSegment: '播放这一段',
    pauseVideo: '暂停视频',
    demoAudioName: '如何流利地说英语',
    demoVideoName: '如何流利地说英语',
    back: '返回',
    readingMode: '阅读',
    autoMode: '自动',
    modeTips: {
      reading: '↑ ← 上一句\n↓ → 下一句\n空格 重播当前句',
      auto: '自动连续播放字幕'
    },
    mode: '模式',
    normal: '正常',
    repeat: '重复',
    subtitlesMode: '字幕',
    textMode: '文本',
    readAlongMode: '跟读',
    smartSplit: '分句',
    smartSplitHint: '选择字幕的断句方式',
    subtitlesHint: '显示字幕',
    textHint: '显示文本',
    translate: '翻译',
    translateHint: '翻译字幕',
    disableTranslation: '关闭翻译',
    translationError: '字幕翻译失败',
    translating: '翻译中...',
    splitByPractice: '跟读 · 标准',
    splitByPracticeShort: '跟读 · 短句',
    splitByComma: '按逗号',
    splitByPeriod: '整句',
    splitByPause: '按停顿',
    noSplit: '原始分段',
    splitHints: {
      practice: '单句尽量不超过 7 秒，适合日常跟读',
      practice_short: '单句尽量不超过 5 秒，适合初学或语速快的内容',
      comma: '遇到逗号和句号就断开',
      period: '保留完整句子，适合精听和理解',
      pause: '说话人在哪里停顿，就在哪里断开',
      none: '转写服务自带的分段',
    },
    exportSettings: '导出设置',
    moreSettings: '更多设置',
    readAlongHint: '逐句跟读：智能、定时、复述三种方式',
    generateSubtitlesTitle: '生成字幕',
    generateSubtitlesAction: '开始生成',
    generationSettingsHint: '选择识别模型和素材语言，然后确认生成字幕。',
    generationUsage: '预计消耗 {count} 点额度',
    transcriptionModel: '识别模型',
    transcriptionLanguage: '素材语言',
    transcriptError: '生成字幕失败',
    insufficientUsage: '额度不足。需要：{required}，剩余：{remaining}',
    microphoneError: '无法访问麦克风，请检查权限设置。',
    microphoneInput: '麦克风',
    readAlongSettings: '跟读设置',
    practiceLanguage: '跟读语言',
    practiceLanguageHint: '用于评分和实时识别。',
    pronunciationScoring: '跟读评分',
    pronunciationScoringHint: '开启后给每句发音打分，每 2 秒消耗 1 额度。关闭后不打分、不消耗额度，只保存录音。',
    microphoneSystemDefault: '系统默认',
    microphoneDeviceNumber: '麦克风 {number}',
    microphoneRefresh: '刷新',
    microphoneRefreshing: '刷新中…',
    yourRecordings: '你的录音',
    playbackError: '播放录音时出错',
    downloadError: '下载录音失败',
    silenceThreshold: '收音阈值',
    silenceTimeout: '收音等待时间',
    vadPauseDelay: '说完判定',
    vadPauseDelayHint: '还没读到句尾时，停顿够久才结束这一句；读到句尾就很快进入下一句。',
    vadPauseDelayDurationHint: '评分关闭时无法识别读到哪个词：说话时长接近原句长度，就当作读到句尾。',
    finishPause: '读到句尾后等待',
    unfinishedPause: '没读到句尾时等待',
    recordingMode: '智能跟读',
    recordingModeTooltip: '播放一句后等待你跟读，说完后自动进入下一句。',
    followingMode: '定时跟读',
    followingModeTooltip: '播放一句后，按原句时长加上固定等待时间自动进入下一句。',
    followingInterval: '每句后多等',
    followingIntervalHint: '每句播完后，等原句时长再加上这段时间，然后自动进入下一句。',
    retellingMode: '复述跟读',
    retellingModeTooltip: '播放一句后录下你的复述，停顿多久都不会结束；说完按“说完了”或回车键进入下一句。不评分。',
    readAlongListenFirst: '先听',
    readAlongSpeakNow: '开口',
    readAlongRecording: '录音',
    readAlongStillListening: '还在听',
    readAlongFinish: '说完了',
    readAlongFinishHint: '立即结束这一句（回车键）',
    endDetectionMode: '判断方式',
    liveRecognition: '实时识别',
    liveRecognitionFallback: '按时长判断',
    liveRecognitionListening: '正在听…',
    liveRecognitionOff: '评分已关闭，按说话时长估算是否读到句尾',
    liveRecognitionLimit: '今日实时识别次数已用完，按说话时长估算是否读到句尾',
    liveRecognitionError: '实时识别暂时连不上，按说话时长估算是否读到句尾',
    tour: {
      next: '下一步',
      skip: '跳过教程',
      replay: '使用教程',
      help: '帮助',
      enable: {
        title: '先打开跟读',
        body: '点高亮的“跟读”按钮。打开后，每播完一句会自动停下来等你开口。',
        action: '打开跟读',
      },
      listen: {
        title: '播放一句原声',
        body: '点播放键、点视频画面、点任意一句字幕，或按空格键，都能播放。这一句播完会自动暂停。',
        action: '播放',
      },
      speak: {
        title: '现在开口跟读',
        body: '不用点任何按钮。看到“开口”就照着高亮的句子读，说完会自动识别并评分。',
        scoring: '读完了，正在评分，几秒后出结果。练习会自动继续，可以接着读下一句。',
        bodyNoScore: '不用点任何按钮。看到“开口”就照着高亮的句子读，说完会自动进入下一句。\n你关掉了跟读评分，这次只录音、不打分。',
      },
      score: {
        title: '看这一句的评分',
        body: '分数出来了。点一下这个分数，看逐词的发音反馈，找出读得不准的词。\n\n发音评分会消耗额度（每 2 秒 1 额度）。不需要打分的话，可以在跟读设置里关掉，只录音不扣额度。',
      },
      modes: {
        title: '三种跟读方式',
        body: '点开可以切换：\n· 智能跟读：等你说完自动进下一句\n· 定时跟读：按固定时间自动往下走\n· 复述跟读：听完凭记忆说，只录音不评分',
      },
      settings: {
        title: '跟读设置',
        body: '点开可以：\n· 选麦克风和跟读语言\n· 开关跟读评分\n· 调“说完判定”的等待时间，没说完就被打断时调长一点',
      },
      split: {
        title: '句子太长或太短',
        body: '点开换分句方式：按适合跟读的短句来分，或保留完整句子。',
      },
      translate: {
        title: '看译文',
        body: '点开选一种语言，每句下面会显示译文，听不懂时对照着看。',
      },
      playback: {
        title: '播放设置',
        body: '这一排从左到右：\n· 字幕字号\n· 音量\n· 播放倍速，听不清就调慢\n· 播放模式，想反复磨一句就选重复',
      },
      finishShort: {
        title: '跟读就是这样',
        body: '点播放，接着读完这段示范剩下的几句，读完给你推荐下一段。想了解跟读方式、翻译、播放速度这些设置，点“看更多设置”。',
        action: '继续练习',
        more: '看更多设置',
      },
      finish: {
        title: '可以开始练了',
        body: '接着练这一条，或去素材库选自己想听的内容。以后想再看教程，点右上角头像里的“使用教程”。',
        library: '去素材库',
        stay: '继续练这条',
      },
    },
    usagePaywall: {
      title: '这个月的额度用完了',
      reason: '发音评分按录音时长扣额度，每 2 秒 1 点。额度已经用完，刚才这一句没有评分。',
      reset: '{date} 自动恢复 {amount} 点免费额度。',
      checkIn: '每天听满 5 分钟打卡，还能领 {amount} 点。',
      noScore: '关掉评分也能继续跟读，只录音、不扣额度。',
      continue: '关掉评分继续练',
      upgrade: '查看升级方案',
      dateLocale: 'zh-CN',
    },
    nextLesson: {
      title: '接下来听这一段',
      intro: '示范练完了。这段是按你的听力水平挑的，点开就能接着练。',
      library: '去素材库',
      start: '开始学习',
      signup: '免费注册，开始学习',
    },
    playRecordings: '播放全部',
    stopRecordings: '停止播放录音',
    myRecordings: '我的录音',
    recordingStorageHint: '录音只保存在这个浏览器里，24 小时后自动清除。需要留存请先下载。',
    playOriginalRecording: '收听这句原声录音',
    downloadRecordings: '下载',
    recordingCount: '{count} 句原声',
    recordingFileSuffix: '跟读原声',
    showSubtitles: '显示字幕',
    hideSubtitles: '隐藏字幕',
    showSubtitlesTooltip: '显示字幕',
    hideSubtitlesTooltip: '隐藏字幕',
    pronunciationAssessment: {
      assessing: '正在评估发音',
      assessmentFailed: '发音评估失败',
      pronunciation: '总分',
      accuracy: '准确度',
      fluency: '流利度',
      completeness: '完整度',
      recognizedText: '识别文本',
      problemWords: '问题词',
      issue: '问题',
      playWordPronunciation: '听发音',
      recordAgain: '重录',
      feedback: '句子反馈',
      summaryExcellent: '读得真棒',
      summaryGood: '整体不错',
      summaryWeakWords: '整体不错，重点练高亮的词。',
      summaryMainIssues: '这句主要问题：',
      summarySeparator: '、',
      summarySentenceEnd: '。',
      issueAccuracy: '发音不准',
      issueFluency: '节奏不稳',
      issueCompleteness: '没有读完整',
      assessmentLanguage: '评分语言',
      pointsCharged: '本次消耗 {points} 额度',
      anonymousAttemptUsed: '本次使用 1 次匿名评分机会',
      insufficientPoints: '额度不足，本次录音已保留但未评分。',
      anonymousLimit: '今天的 5 次匿名评分已用完，请明天再试或登录后继续。',
      errorTypes: {
        Omission: '漏读',
        Insertion: '多读',
        Mispronunciation: '发音不准',
        UnexpectedBreak: '异常停顿',
        MissingBreak: '缺少停顿',
        Monotone: '语调单一',
      },
    },
  },
  sentenceExplanation: {
    action: '解释这句',
    title: 'AI 单句解释',
    loading: '正在解释这句话...',
    regenerate: '重新解释',
    retry: '重试',
    followUpLabel: '继续问',
    followUps: {
      grammar: '拆解结构',
      rephrase: '换个说法',
      examples: '学着用',
    },
    saveToNotebook: '加入学习本',
    savedToNotebook: '已加入学习本',
    saveFailed: '加入学习本失败，请重试',
    quotaRemaining: '本月还可用 {count} 次',
    monthlyLimitReached: '本月的解释次数已用完，下个月 1 日自动恢复。',
    loginRequired: '请先登录，再使用单句解释。',
    generateFailed: '生成解释失败，请重试',
  },
  learningAssistant: {
    title: '学习助手',
    pronunciation: '发音反馈',
    explanation: '单句解释',
    noAssessment: '这句话还没有发音评分。完成一次跟读后即可查看反馈。',
  },
  vocabulary: {
    loading: '查词中...',
    addToVocabulary: '加入单词本',
    saving: '保存中...',
    saved: '已加入单词本',
    updated: '已更新单词本',
    noTranslation: '未找到翻译',
    loginRequired: '请先登录再保存单词。',
    lookupFailed: '查词失败',
    saveFailed: '保存失败',
    listen: '发音',
    inContext: '本句中',
    otherSenses: '其他常见义项',
    baseForm: '原形',
    retry: '重试'
  },
  textToSpeech: {
    subtitle: '把文字转成自然语音，自由选择声音和语速。',
    title: '文本转语音',
    textPlaceholder: '在此输入或粘贴文本...',
    characterCount: '字符',
    provider: '声音风格',
    providers: {
      google: '多语言声音库',
      openai: '自然人声'
    },
    gender: { female: '女声', male: '男声' },
    providerHint: '多语言声音库可选语言和口音；自然人声语气更接近真人。',
    voiceSelection: '语音选择',
    voiceLabel: '说话人',
    speedLabel: '语速',
    googleLanguage: '语言',
    googleVoice: '声音',
    usageCost: '消耗：{cost}额度',
    insufficientUsage: '剩余额度不足',
    submittingVoice: '正在提交…',
    errors: {
      emptyContent: '请输入文本内容',
      characterLimitExceeded: '超出字符限制',
      pasteFailed: '从剪贴板粘贴失败',
      generic: '发生错误'
    },
    previewButton: '试听语音示例',
    previewError: '播放预览失败',
    playVoicePreview: '播放语音示例'
  },
  exportPanel: {
    export: '导出',
    downloadAudio: '下载音频',
    renameFile: '重命名文件',
    deleteFile: '删除文件',
  },
  feedback: {
    title: '意见反馈',
    intro: '遇到问题或有改进建议，都可以告诉我们。',
    messageLabel: '描述',
    messagePlaceholder: '遇到了什么问题？在哪一步出现的？或者希望我们改进什么？',
    screenshotsLabel: '截图',
    screenshotsHint: '选填，最多 {max} 张，可直接 Ctrl+V 粘贴',
    addScreenshot: '点击添加、拖入或粘贴',
    screenshotAlt: '截图 {index}',
    removeScreenshot: '删除截图 {index}',
    emailLabel: '联系邮箱',
    emailHint: '选填，方便我们回复你',
    contextNote: '提交时会附上当前页面和浏览器信息，方便排查问题。',
    contextNotePlayer: '提交时会附上当前页面、浏览器信息，以及正在练的素材和句子，方便排查问题。',
    submit: '提交反馈',
    submitting: '提交中…',
    thanks: '已收到你的反馈，谢谢！我们会尽快查看。',
    thanksDetail: '如果留了邮箱，处理后会回复你。',
    errors: {
      tooManyScreenshots: '最多添加 {max} 张截图',
      notImage: '只支持 PNG、JPG、WebP、GIF 格式的图片',
      tooLarge: '单张截图不能超过 5MB',
      FEEDBACK_INVALID: '提交的内容有误，请检查描述和邮箱后重试',
      FEEDBACK_RATE_LIMIT: '今天提交的反馈太多了，请明天再试，或直接发邮件到 goodscriber@gmail.com',
      FEEDBACK_TOO_LARGE: '截图总大小超出限制，请删掉一些再试'
    },
    admin: {
      tab: '用户反馈',
      title: '用户反馈',
      filterNew: '未处理',
      filterAll: '全部',
      empty: '暂无反馈',
      anonymous: '未登录用户',
      contact: '联系邮箱',
      markResolved: '标记已处理',
      markNew: '改回未处理',
      status: { new: '未处理', resolved: '已处理' },
      context: {
        page: '页面',
        view: '视图',
        audioName: '素材',
        sentenceIndex: '句子序号',
        sentenceText: '当前句',
        currentTime: '播放位置（秒）',
        audioId: '文件 ID',
        materialId: '素材 ID',
        locale: '界面语言',
        viewport: '窗口大小',
        userAgent: '浏览器'
      }
    }
  },
  common: {
    mainlandAccessNotice: '在中国大陆使用需要能够访问油管的网络，否则登录和视频无法加载。',
    error: '错误',
    success: '成功',
    loading: '加载中',
    cancel: '取消',
    confirm: '确定',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    close: '关闭',
    generate: "生成",
    processing: "处理中...",
    paste: '粘贴',
    generating: '正在生成...',
    generateSubtitles: '生成字幕',
    subtitlesGenerated: '字幕生成成功',
    generateSubtitlesFailed: '生成字幕失败',
    unknownError: '发生未知错误',
    play: '播放',
    stop: '停止',
    download: '下载',
  },
  premium: {
    billingPeriod: '付费周期',
    purchaseMode: {
      label: '购买方式',
      subscription: '订阅套餐',
      credits: '单买额度'
    },
    subscriptionNote: '自动续费，可随时取消',
    creditPackNote: '一次性付款，额度永久有效',
    paymentMethodNote: {
      subscription: '订阅只支持银行卡付款，单买额度可用支付宝',
      credits: '可用支付宝付款：结账页按纽币计价，支付宝会自动换算成人民币'
    },
    creditPackAllowanceNote: '优先使用月度额度，再使用永久额度。永久额度有余额时，可享受 Pro 的上传、文本和队列权益。',
    title: '选择您的计划',
    monthly: '月付',
    yearly: '年付',
    autoRenewal: '自动续费',
    allowanceNote: '发音评分、转录和语音合成的上限，均按全部月度额度用于该单项功能计算，三项共享额度。',
    referenceNote: {
      yearly: '划线价是按月付 12 个月的总价。',
      credits: '划线价按 2,000 额度包的单价折算。'
    },
    firstPurchase: {
      subscriptionBadge: '首次订阅前 {months} 个月 {fold} 折',
      subscriptionNote: '首次订阅优惠：前 {months} 个月按 {fold} 折收费，第 {nextMonth} 个月起按划线原价续费，可随时取消。',
      creditsBadge: '首次购买 {fold} 折',
      creditsNote: '首次购买优惠：划线价是原价，仅限第一笔订单。'
    },
    cta: {
      current: '当前方案',
      pro: '选择专业版',
      premium: '选择高级版',
      manageExisting: '请先管理当前订阅',
      activePlan: '当前会员生效中',
      included: '已包含基础权益'
    },
    activeSubscription: {
      title: '你已有生效中的会员套餐',
      description: '变更套餐或取消自动续费，请进入 Stripe 账单管理。',
      grantedDescription: '该会员没有关联 Stripe 自动续费，无需退订。'
    },
    featureLabels: {
      credits: '额度',
      pronunciation: '发音评分',
      transcription: '转录时长',
      tts: '语音合成',
      upload: '音视频上传',
      text: '文本转语音',
      priority: '队列'
    },
    freePlan: {
      title: 'GoodScriber 免费版',
      description: '轻量体验',
      price: 'US$0 / 月',
      transcriptLimit: '每月 200 额度',
      uploadLimit: '20 分钟 / 50MB',
      characterLimit: '每次 5,000 字符',
      priority: '较低优先级',
      description1: '20 分钟转录；语音最高 6,000 字符',
      description2: '单个文件最长 20 分钟，最大 50MB',
      description3: '文本转语音每次最多 5,000 字符',
      description4: '转录处理时间较长',
      specs: {
        credits: '200 / 月',
        pronunciation: '约 6 分钟 / 月',
        transcription: '20 分钟 / 月',
        tts: '最高 6,000 字符 / 月',
        upload: '最长 20 分钟，最大 50MB',
        text: '每次最多 5,000 字符',
        priority: '标准'
      }
    },
    proPlan: {
      monthlySubscription: 'US$8.99 / 月',
      yearlySubscription: 'US$89.90 / 年',
      title: 'GoodScriber 专业版',
      yearlyDiscount: '相当于免 2 个月',
      description: '日常学习',
      transcriptLimit: '每月 5,000 额度',
      uploadLimit: '30 分钟 / 100MB',
      characterLimit: '每次 10,000 字符',
      priority: '较高优先级',
      description1: '500 分钟转录；语音最高 150,000 字符',
      description2: '单个文件最长 30 分钟，最大 100MB',
      description3: '文本转语音每次最多 10,000 字符',
      description4: "我们将优先处理您的文件，转录速度更快",
      specs: {
        credits: '5,000 / 月',
        pronunciation: '约 167 分钟 / 月',
        transcription: '500 分钟 / 月',
        tts: '最高 150,000 字符 / 月',
        upload: '最长 30 分钟，最大 100MB',
        text: '每次最多 10,000 字符',
        priority: '较快'
      }
    },
    premiumPlan: {
      monthlySubscription: 'US$16.99 / 月',
      yearlySubscription: 'US$169.90 / 年',
      title: 'GoodScriber 高级版',
      yearlyDiscount: '相当于免 2 个月',
      description: '高频使用',
      transcriptLimit: '每月 10,000 额度',
      uploadLimit: '60 分钟 / 200MB',
      characterLimit: '每次 20,000 字符',
      priority: '最高优先级',
      description1: '1,000 分钟转录；语音最高 300,000 字符',
      description2: '单个文件最长 60 分钟，最大 200MB',
      description3: '文本转语音每次最多 20,000 字符',
      description4: "我们将优先处理您的文件，转录速度最快",
      specs: {
        credits: '10,000 / 月',
        pronunciation: '约 333 分钟 / 月',
        transcription: '1,000 分钟 / 月',
        tts: '最高 300,000 字符 / 月',
        upload: '最长 60 分钟，最大 200MB',
        text: '每次最多 20,000 字符',
        priority: '最快'
      }
    },
    creditPacks: {
      cta: '购买额度',
      bestValue: '最划算',
      featureLabels: {
        balance: '额度',
        access: '功能权限',
        expiry: '有效期'
      },
      2000: {
        title: '2,000 额度',
        description: '适合偶尔处理项目',
        price: 'US$4.99',
        features: {
          balance: '2,000 永久额度',
          access: '有余额时享受 Pro 权益',
          expiry: '永久有效'
        }
      },
      5000: {
        title: '5,000 额度',
        description: '适合经常处理项目',
        price: 'US$11.99',
        features: {
          balance: '5,000 永久额度',
          access: '有余额时享受 Pro 权益',
          expiry: '永久有效'
        }
      },
      10000: {
        title: '10,000 额度',
        description: '单次购买单价最低',
        price: 'US$21.99',
        features: {
          balance: '10,000 永久额度',
          access: '有余额时享受 Pro 权益',
          expiry: '永久有效'
        }
      }
    },
    premiumType: {
      'monthly_oneTime': '月度会员',
      'quarterly_oneTime': '季度会员',
      'halfYearly_oneTime': '半年度会员',
      'monthly_autoRenewal': '月度自动续费',
      'yearly_oneTime': '年度会员',
      'yearly_autoRenewal': '年度自动续费'
    },
    premiumExpiry: '{date} 到期'
  },
  auth: {
    loginTitle: '登录',
    signupTitle: '注册',
    email: '邮箱',
    emailPlaceholder: '输入你的邮箱',
    password: '密码',
    passwordPlaceholder: '输入你的密码',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '确认你的密码',
    loginButton: '登录',
    loggingIn: '登录中',
    signupButton: '注册',
    loginWithGoogle: '使用 Gmail 登录',
    signupWithGoogle: '使用 Gmail 注册',
    noAccount: "没有账户？",
    hasAccount: '已经有账户？',
    errors: {
      invalidCredentials: '邮箱或密码不正确。',
      emailNotVerified: '请先验证你的邮箱。',
      networkError: '网络连接失败，请检查网络后重试。',
      tooManyRequests: '尝试次数过多，请稍后再试。',
      emailInUse: '这个邮箱已经注册过了。',
      invalidEmail: '邮箱格式不正确。',
      weakPassword: '密码至少需要 6 位。',
      popupBlocked: '浏览器拦截了 Google 登录弹窗，请允许弹窗后重试。',
      unknown: '出了点问题，请稍后重试。'
    },
    welcomeBack: '欢迎回来',
    loginSubtitle: '登录后继续你的跟读练习。',
    createAccount: '免费创建账号',
    signupSubtitle: '免费账户每月送 200 点数，注册后就能开始逐句跟读。',
    continueWithGoogle: '使用 Google 继续',
    orEmail: '或使用邮箱',
    forgotPassword: '忘记密码？',
    passwordHint: '至少 6 位字符',
    createAccountButton: '创建账号',
    creatingAccount: '创建中…',
    haveReferral: '有邀请码？',
    termsPrefix: '注册即表示你同意',
    termsLink: '服务条款',
    termsAnd: '和',
    privacyLink: '隐私政策',
    termsSuffix: '。',
    goLogin: '去登录',
    verifyTitle: '去邮箱完成验证',
    verifyText: '验证链接已发送到 {email}，点开链接后回来登录即可。',
    verifyHint: '没收到？看看垃圾邮件文件夹，或者重新发送。',
    verifiedGoLogin: '我已完成验证，去登录',
    resendVerification: '重新发送',
    resendIn: '{seconds} 秒后可重新发送',
    resendSuccess: '已重新发送，请查收。',
    resetTitle: '重置密码',
    resetSubtitle: '输入注册时用的邮箱，我们会发送重置密码的链接。',
    sendResetLink: '发送重置链接',
    sendingResetLink: '发送中…',
    resetSent: '重置链接已发送到 {email}，请查收邮件。',
    backToLogin: '返回登录',
    visualTitle: '听一句，跟一句，马上看到发音评分',
    backToSite: '返回 GoodScriber',
    loginError: '登录失败，请重试。',
    signupError: '注册失败，请重试。',
    googleLoginError: '使用 Google 登录失败，请重试。',
    googleSignupError: '使用 Google 注册失败，请重试。',
    passwordTooShort: '密码至少 6 个字符',
    passwordsDoNotMatch: '密码不匹配',
    signupSuccess: '注册成功！我们已经将验证链接发送到你的邮箱，请在登录前验证。',
    showPassword: '显示密码',
    hidePassword: '隐藏密码'
  },
  paymentSuccess: {
    title: '支付成功！',
    subtitle: '感谢您订阅 GoodScriber {plan}',
    subscriptionConfirmed: '您的 GoodScriber 订阅已生效',
    description: '您现在可以使用所有高级功能了',
    creditPurchase: {
      subtitle: '永久额度已到账',
      description: '系统会优先使用月度额度，永久额度永不过期。',
      details: '额度购买详情',
      added: '本次到账',
      permanentBalance: '永久额度余额',
      access: '功能限制',
      proAccess: '有余额时享受 Pro',
      expiry: '有效期',
      never: '永久'
    },
    features: {
      title: '您现在可以：',
      list: [
        '更多每月转写和语音合成额度',
        '获得对应套餐的音视频上传上限',
        '获得对应套餐的文本转语音上限',
        '更高优先级，转写更快完成'
      ]
    },
    buttons: {
      backToHome: '返回首页',
      viewMembership: '查看会员信息'
    }
  },
  membership: {
    details: '会员详情',
    plan: '会员计划',
    startDate: '开始时间',
    endDate: '到期时间',
    type: '付款方式',
    autoRenewal: '自动续费',
    oneTime: '一次性付款',
    unknown: '未知计划',
    planTypes: {
      pro: '专业版',
      premium: '高级版',
      monthly: '月度会员',
      yearly: '年度会员',
      halfYearly: '半年会员',
      quarterly: '季度会员'
    }
  },
  paymentCancel: {
    title: '支付已取消',
    description: '您可以随时重新尝试购买会员',
    buttons: {
      backToHome: '返回首页'
    }
  },
  material: {
    title: '听读素材库',
    subtitle: '挑一个合集，逐句精听、跟读',
    recentTitle: '继续上次练习',
    recentContinue: '接着练',
    recentAgain: '再练一遍',
    recentOpening: '正在打开',
    recentUntitled: '未命名内容',
    recentPosition: '第 {index}/{total} 句',
    recentPositionOnly: '听到第 {index} 句',
    recentPercent: '已听 {percent}%',
    recentFinished: '已听完',
    recentMissing: '这条内容已被删除，无法打开。',
    recentFailed: '暂时打不开，请稍后重试。',
    videoSection: '视频',
    audioSection: '音频',
    youtubeVlogTitle: '生活 Vlog',
    youtubeVlogDesc: '博主的日常与旅行，自然语速',
    youtubeBeginnerTitle: '慢速入门',
    youtubeBeginnerDesc: '动画和慢速讲解，从日常表达学起',
    youtubeRealLifeTitle: '真实场景',
    youtubeRealLifeDesc: '点餐、购物、出行里的地道对话',
    ieltsTitle: '雅思听力 IELTS',
    ieltsDesc: '剑桥雅思 5–20 听力真题',
    podcastsTitle: '英语播客',
    podcastsDesc: 'EnglishPod 情景对话与沟通话题',
    listeningLessonsByLevelTitle: '分级听力',
    listeningLessonsByLevelDesc: 'A1 到 C1 五个级别的一分钟短课',
    naturalEnglishConversationsTitle: '日常对话',
    naturalEnglishConversationsDesc: '1600 多节日常英语短对话',
    audiobooksadultsTitle: '有声书',
    audiobooksadultsDesc: '成人非虚构有声书，如《原子习惯》',
    tededTitle: 'TED-Ed 动画课',
    tededDesc: '几分钟一集的知识动画短片',
    bbc6minuteTitle: 'BBC 六分钟英语',
    bbc6minuteDesc: '每集 6 分钟，围绕一个话题聊',
    toeflTitle: '托福听力 TOEFL',
    toeflDesc: '托福听力的对话与学术讲座'
  },
  materialCategory: {
    subscribers: '{count}订阅',
    views: '{count}次观看',
    resultCount: '{count} 条素材',
    clearFilters: '清除筛选',
    filterSeparator: '：',
    levelFilter: '难度',
    topicFilter: '领域',
    levelAll: '全部',
    topicAll: '全部',
    purchaseConfirm: '该素材需要消耗 {price} 点数',
    generateConfirmTitle: '确认消耗点数',
    generateConfirm: '此音频需要消耗:',
    currentPoints: '当前点数',
    cancel: '取消',
    confirm: '确认',
    processing: '正在打开…',
    pleaseLogin: '请先登录',
    purchaseSuccess: '购买成功',
    free: '免费',
    freeUnlocked: '已免费解锁，还可免费解锁 {count} 个素材',
    freeUnlockedLast: '已免费解锁，之后的素材按点数解锁',
    purchaseFailed: '购买失败',
    insufficientPoints: '点数不足',
    loadFailed: '获取素材失败，请稍后重试',
    loading: '加载中...',
    filterAll: '全部',
    filterPurchased: '已拥有',
    filterUnpurchased: '未拥有',
    noResults: '没有找到匹配的素材'
  },
  materialAdmin: {
    title: '素材库管理',
    subtitle: '管理素材分类、合集，以及音频和 YouTube 视频素材',
    backToLibrary: '返回素材库',
    checkingAccess: '正在检查管理员权限...',
    accessDenied: '请输入管理密码',
    accessHint: '密码来自后端环境变量 ADMIN_MATERIAL_PASSWORD。',
    passwordPlaceholder: '管理密码',
    login: '进入管理',
    logout: '退出管理',
    invalidPassword: '管理密码不正确',
    browse: '目录浏览',
    directory: '目录',
    selectDirectory: '请选择目录',
    itemCount: '{count} 个素材',
    seedYouTubeLibrary: '初始化 YouTube 目录',
    seedingYouTubeLibrary: '正在初始化...',
    youtubeLibrarySeeded: '已新增 {categories} 个分类、{collections} 个频道合集',
    youtubeLibrarySeedFailed: 'YouTube 目录初始化失败',
    syncYouTubeStats: '同步 YouTube 数据',
    syncingYouTubeStats: '正在同步...',
    youtubeStatsSynced: '已更新 {collections} 个频道、{items} 条视频的 YouTube 数据',
    youtubeStatsSyncFailed: 'YouTube 数据同步失败',
    importYouTube: '导入 YouTube',
    importYouTubeTitle: '添加 YouTube 学习素材',
    importYouTubeHint: '先检查公开视频，再在后台生成逐句字幕。处理期间素材保持隐藏。',
    youtubeUrlPlaceholder: '粘贴 YouTube 视频地址',
    checkVideo: '检查视频',
    checkingVideo: '检查中...',
    videoChecked: '视频可用',
    publishAfterProcessing: '字幕生成成功后自动上线',
    createYouTubeMaterial: '创建素材并生成字幕',
    creatingYouTubeMaterial: '正在创建...',
    youtubeMaterialQueued: 'YouTube 素材已创建，正在后台生成字幕',
    youtubeInspectFailed: '无法读取这个 YouTube 视频',
    youtubeImportFailed: 'YouTube 素材创建失败',
    uploadFiles: '上传音频文件',
    uploadSelected: '上传 {count} 个文件',
    uploading: '上传中...',
    uploaded: '已上传 {count} 个文件',
    uploadFailed: '上传失败',
    emptyCollection: '这个合集中还没有素材',
    invalidDocumentId: 'ID 不能包含 /，建议只用英文、数字、横线或下划线',
    generateAfterUpload: '上传后自动生成字幕',
    generateSubtitles: '生成当前合集字幕',
    generatingSubtitles: '生成字幕中...',
    generateSubtitlesFailed: '生成字幕失败',
    subtitlesGenerated: '已生成 {count} 个素材的字幕',
    subtitlesGeneratedWithFailures: '字幕生成完成：成功 {completed} 个，失败 {failed} 个',
    transcriptionProvider: '转写服务',
    transcriptionLanguage: '转写语言',
    transcriptionStatus: '字幕状态',
    completed: '已完成',
    noSubtitles: '无字幕',
    categories: '分类',
    collections: '合集',
    items: '素材',
    import: '批量导入',
    newCategory: '新增分类',
    editCategory: '编辑分类',
    newCollection: '新增合集',
    editCollection: '编辑合集',
    newItem: '新增素材',
    editItem: '编辑素材',
    titleZh: '中文标题',
    titleEn: '英文标题',
    itemTitle: '素材标题',
    descriptionZh: '中文简介',
    descriptionEn: '英文简介',
    coverUrl: '封面 URL',
    uploadCover: '上传封面',
    coverUploading: '上传中...',
    coverUploaded: '封面已上传',
    coverUploadedAndSaved: '封面已上传并保存',
    coverUploadFailed: '封面上传失败',
    coverUploadMissingTarget: '请先填写分类、合集或素材 ID',
    coverAutoHint: '上传后自动生成 URL，可留空继承上级封面',
    sortOrder: '排序',
    defaultPrice: '默认价格',
    price: '价格',
    enabled: '上线显示',
    save: '保存',
    reset: '重置',
    refresh: '刷新',
    categoryList: '分类列表',
    collectionList: '合集列表',
    itemList: '素材列表',
    category: '分类',
    collection: '合集',
    selectCategory: '选择分类',
    selectCollection: '选择合集',
    allCategories: '全部分类',
    level: '难度',
    cefrLevel: '等级',
    topics: '领域',
    topicsHint: '领域（最多选 2 个，不选则由自动标签决定）',
    levelAuto: '自动（当前 {level}）',
    manualMark: '（手动）',
    gradeLevels: '计算分级',
    gradeLevelsConfirm: '将为当前分类 {graded} 条素材写入等级（跳过 {skipped} 条：无字幕或已手动设置）。分布：{distribution}',
    gradeLevelsDone: '已更新 {graded} 条素材的等级',
    repriceByDuration: '按时长定价',
    repriceByDurationConfirm: '按时长重新设置当前分类的点数：10 分钟内 20 点，20 分钟内 30 点，30 分钟内 40 点，更长 50 点。将修改 {changed} 条（没有时长的 {skipped} 条不改）。分布：{distribution}',
    repriceTier: '{price} 点 {count} 条',
    repriceByDurationDone: '已修改 {changed} 条素材的点数',
    tagTopics: '生成领域标签',
    tagTopicsConfirm: '将调用 DeepSeek 为当前分类中还没有领域标签的素材打标签，手动设置过的不会改动。继续吗？',
    tagTopicsDone: '已标注 {tagged} 条，失败 {failed} 条。{distribution}',
    classifyFailed: '操作失败，请稍后重试',
    source: '来源',
    sourceType: '来源类型',
    audioSource: '上传音频',
    youtubeUrl: 'YouTube 地址',
    audioFilePath: '音频路径',
    duration: '时长（秒）',
    tags: '标签',
    status: '状态',
    actions: '操作',
    visible: '显示',
    hidden: '隐藏',
    edit: '编辑',
    hide: '隐藏',
    show: '显示',
    saved: '已保存',
    collectionPriceSynced: '已保存，并同步更新合集内 {count} 个素材的价格',
    searchItems: '搜索素材',
    importItems: '批量导入素材',
    importHint: '支持 JSON 数组或 CSV。必填字段：id、categoryId、collectionId、audioFilePath。',
    fillExample: '填入示例',
    importRows: '导入 {count} 条',
    preview: '预览',
    invalidImportRow: '第 {index} 行缺少必填字段',
    imported: '已导入 {count} 条素材',
    subtitlesGeneratedSummary: '字幕生成完成：成功 {completed} 个，跳过 {skipped} 个，失败 {failed} 个',
    delete: '删除',
    cancel: '取消',
    deleteCollection: '删除合集',
    deleteCollectionTitle: '删除合集',
    deleteCollectionConfirm: '确定删除「{title}」吗？这个合集下的 {count} 个素材、音频文件和字幕记录都会删除。',
    deleteCollectionSuccess: '已删除合集，并删除 {count} 个素材',
    deleteCollectionFailed: '删除合集失败',
    deleteItemTitle: '删除素材',
    deleteItemConfirm: '确定删除「{title}」吗？音频文件和字幕记录都会删除。',
    deleteItemSuccess: '已删除素材',
    deleteItemFailed: '删除素材失败'
  },
  quickListening: {
    firstQuestion: '能听懂这一段吗？',
    harderQuestion: '不错，再来一段难一点的',
    easierQuestion: '没关系，换一段简单点的',
    play: '播放',
    pause: '暂停',
    revealHint: '听完选一下，字幕会显示出来',
    yes: '能听懂',
    no: '听不懂',
    nextClip: '下一段',
    seeResult: '查看结果',
    resultTitle: '你的听力大约在 {level}',
    resultHint: '素材库会优先给你这个难度的内容。之后可以在学习档案里做完整测试，结果更准。',
    retake: '重新测一次'
  },
  learnerProfile: {
    sourceLabels: {
      self: '自评',
      quick: '快速测试',
      test: '测试结果'
    },
    speakingSetupTitle: '再测一下口语',
    speakingSetupHint: '前 3 题照着念，后 2 题用英语回答问题，大约 3 分钟，需要麦克风。',
    speakingResultTitle: '你的口语大约在 {level}',
    speakingResultHint: '结果已存进学习档案，随时可以重新测试。',
    skipSpeaking: '暂不测试，去选素材',
    returnToSetup: '返回新手引导',
    continueSetup: '继续设置学习偏好',
    setupLater: '稍后设置',
    finishSetup: '设置完成，去选素材',
    listeningTestAction: '开始听力测试',
    speakingTestAction: '开始口语测试',
    levelChoiceHint: '选择最接近你的水平，不确定可以先测试。',
    title: '学习偏好',
    subtitle: '告诉我们你的水平和兴趣，素材库会据此帮你筛选。随时可以改。',
    listeningTitle: '你能听懂多少英语？',
    listeningHint: '选最接近你的一项，对照每级下面的素材例子就好。',
    speakingTitle: '你能说到什么程度？',
    speakingHint: '选最接近你的一项。不确定可以先跳过，以后再改。',
    listening: '听力',
    speaking: '口语',
    levelNames: {
      A1: '入门',
      A2: '基础',
      B1: '进阶',
      B2: '中高级',
      C1: '高级',
      C2: '精通'
    },
    listeningLevels: {
      A1: '只能听懂很慢、很清楚的简单词句',
      A2: '能听懂慢速的日常对话，比如问路、购物',
      B1: '慢速节目能听懂大意，正常语速的 Vlog 跟不上',
      B2: '正常语速的 Vlog 和访谈大多能听懂',
      C1: '快语速、口音和俚语也基本能听懂',
      C2: '和听中文差不多，几乎什么都能听懂'
    },
    listeningExamples: {
      A1: '慢速动画短片',
      A2: '慢速入门、分级听力',
      B1: '日常对话、雅思听力',
      B2: 'BBC 六分钟英语、英语播客',
      C1: '生活 Vlog、有声书',
      C2: '美剧、新闻直播不看字幕'
    },
    speakingLevels: {
      A1: '能说几个简单的词和句子',
      A2: '能用简单句完成日常交流',
      B1: '能聊熟悉的话题，但常要停下来想',
      B2: '能比较流利地讨论大多数话题',
      C1: '表达自然流畅，很少卡壳',
      C2: '接近母语者，表达精准自如'
    },
    speakingExamples: {
      A1: '介绍名字、来自哪里',
      A2: '点餐、问路、买东西',
      B1: '聊工作、爱好和周末计划',
      B2: '说出观点并给理由',
      C1: '开会发言、即兴演讲',
      C2: '谈判、辩论、讲笑话'
    },
    examplePrefix: '比如：',
    interestsTitle: '你对哪些内容感兴趣？',
    interestsHint: '选几个，素材库会把这些领域排在前面。',
    goalsTitle: '你学英语是为了什么？',
    goalsHint: '可以多选。',
    saveFailed: '保存失败，请检查网络后重试',
    syncHint: '还没登录时，偏好只保存在这台设备上；登录后会同步到账号。',
    onboardingTitle: '先设置你的学习偏好',
    takeTest: '测一下我的水平',
    notSure: '不确定？测一下',
    notSet: '未设置',
    levelsGroup: '英语水平',
    interestsGroup: '感兴趣的领域',
    goalsGroup: '学习目标',
    saving: '正在保存…',
    savedState: '已保存',
    unsavedHint: '有修改还没保存',
    saveAction: '保存修改',
    entryLabel: '我的水平',
    entrySetup: '设置我的水平',
    skip: '跳过',
    back: '上一步',
    next: '下一步',
    finish: '完成',
    topics: {
      'daily-life': '日常生活',
      travel: '旅行',
      food: '美食',
      work: '职场',
      business: '商业财经',
      tech: '科技',
      science: '科学自然',
      news: '新闻时事',
      culture: '影视娱乐',
      history: '历史人文',
      stories: '故事文学',
      health: '健康生活',
      sports: '体育健身',
      psychology: '心理成长',
      study: '学习方法'
    },
    goals: {
      conversation: '日常交流',
      media: '看剧看视频不靠字幕',
      work: '工作需要',
      abroad: '出国留学或生活',
      exam: '考试（雅思、托福等）'
    },
    goalDescriptions: {
      conversation: '和外国朋友、同事自然聊天',
      media: '追剧、看 YouTube 能直接听懂',
      work: '开会、写邮件、和海外客户沟通',
      abroad: '留学、移民、长期旅居',
      exam: '雅思、托福、四六级听说'
    }
  },
  levelTest: {
    listeningRange: '最高可测至 C1。',
    speakingRange: '最高可测至 C2。',
    backToProfile: '返回学习偏好',
    title: '英语水平测试',
    subtitle: '测完自动更新你的学习偏好，素材库会按这个等级帮你筛选。',
    listeningName: '听力测试',
    listeningMeta: "10 题 · 约 3–5 分钟",
    listeningIntro: "听音完成 6 道选择题和 4 道整句听写，每段最多听两遍。",
    preparingTest: "正在抽题…",
    dictationPlayFirst: '播放录音后，即可边听边输入',
    dictationType: "整句听写",
    comprehensionType: "听力理解",
    dictationTitle: "写出你听到的完整句子",
    dictationHint: "可以边听边写，重听时内容会保留。大小写和标点不影响结果。",
    dictationAnswer: "你的句子",
    dictationPlaceholder: "在这里输入听到的英语…",
    dictationShortcut: "Ctrl / ⌘ + Enter 提交；Enter 换行",
    dictationRecognition: "听写词语识别",
    listeningAssessing: "正在综合评定听力等级…",
    listeningAssessingHint: "正在核对理解题与听写，并结合题目难度分析你的表现。",
    listeningAssessmentFailed: "暂时未能完成评定",
    retryAssessment: "用这些答案重新评定",
    listeningStartFailed: "暂时无法抽题，请检查网络后重试。",
    listeningSessionExpired: "本次测试已过期，请重新开始。",
    listeningRateLimit: "短时间内评定次数较多，请稍后再试。",
    listeningRetryHint: "你的答案仍保留在本页，可以重新评定，无需再做一遍。",
    referenceSentence: "原句：",
    wordStatus: {"correct": "听对", "wrong": "听错", "missing": "漏词", "extra": "多写", "spelling": "拼写"},
    listeningProgress: '第 {n} / {total} 题',
    testProgress: '测试进度',
    audioLoading: '正在加载录音…',
    audioPlaying: '正在播放，请听完这段录音',
    audioFailed: '录音播放失败，请重试。本次播放不计次数。',
    nextQuestion: '下一题',
    seeResult: '查看结果',
    previousQuestion: "上一题",
    partialAnswer: "部分正确",
    originalAndExplanation: "原文与解析",
    dictationCompactScore: "词语识别 {accuracy}%",
    expandAssessment: "查看答题详情",
    listeningBasis: '为什么得到这个等级',
    skillBreakdown: '各项理解表现',
    listeningSkills: { detail: '关键细节', gist: '整体主旨', intent: '说话意图', inference: '态度与推断', dictation: '整句听写' },
    selectedAnswer: '你的答案：',
    correctAnswer: '正确答案：',
    incorrect: '未答对',
    clipTranscript: '展开这段录音的原文',
    replayQuestion: '重听第 {n} 题录音',
    materialSource: '素材来源：',
    speakingName: '口语测试',
    speakingMeta: '5 题 · 约 3 分钟',
    speakingFirstFree: '第一次测试免费',
    speakingCost: '完成后扣除 {n} 额度',
    startingTest: '正在准备…',
    speakingInsufficientUsage: '额度不足，请补充额度后再测试。',
    speakingIntro: '前 3 题照着念，后 2 题用英语回答问题。',
    startAnswer: '开始回答',
    start: '开始测试',
    allTests: '全部测试',
    questionNumber: '第 {n} 题',
    play: '播放',
    replay: '再听一次',
    playsLeft: '还能再听 {n} 次',
    playShortcut: '空格播放 / 重听',
    noPlaysLeft: '已经听了 2 次',
    playFirst: '先听完一遍再选',
    notHeard: '没听清',
    correct: '答对了',
    wrong: '正确答案是 {answer}',
    listeningResult: '你的听力等级',
    speakingResult: '你的口语等级',
    savedToProfile: '已更新学习偏好',
    browseMaterials: '按这个等级看素材',
    retake: '重测',
    notAccurate: '觉得不准？可以在学习偏好里手动改。',
    openProfile: '打开学习偏好',
    loginRequired: '口语测试需要登录，结果会保存到你的账号。',
    login: '登录',
    lastResult: '上次结果',
    viewReport: '查看上次结果',
    ratingBasis: '等级是怎么得出的',
    contentMethod: '先根据两道问答的词汇、语法、连贯性和切题程度评定内容等级，再结合朗读发音和说话流畅程度确定最终等级。每题的内容等级仅供参考。',
    capBasis: '朗读平均 {score} 分，对应等级上限 {cap}。发音低于 60 / 75 / 85 分时，最高分别为 B1 / B2 / C1。',
    fluencyBasis: '两道问答平均语速 {speed} 词/分钟，超过 3 秒的停顿共 {pauses} 次。',
    fluencyRule: '平均语速低于 80 词/分钟，或长停顿累计超过 3 次，最终等级再降一级，最低 A1。',
    insufficientContent: '两道问答合计不足 15 个词，内容样本不足，按规则记为 A1，未进行逐题内容评级。',
    questionReview: '逐题回顾',
    transcriptNote: '下方是自动识别的文字，可能存在识别误差。问答内容评价依据这些文字，发音分来自录音评估。',
    readNumber: '朗读 {n}',
    answerNumber: '问答 {n}',
    recognizedSpeech: '识别出的朗读',
    yourAnswer: '你的回答 · 自动转写',
    noTranscript: '未识别到回答',
    unscoredRead: '未获得分数，平均分按 0 分计',
    answerContentLevel: '本题内容等级',
    longPauseLabel: '长停顿（超过 3 秒）',
    nextStep: '改进建议：',
    oldReport: '这次历史测试未保存逐题明细；新完成的测试会展示完整回顾。',
    micDenied: '没有拿到麦克风权限。请在浏览器地址栏允许麦克风后重试。',
    taskRead: '朗读',
    taskAnswer: '回答问题',
    taskProgress: '{n} / {total}',
    readHint: '大声朗读这句话。',
    answerHint: '用英语回答问题，不要朗读题目。',
    accuracy: '准确度',
    fluency: '流畅度',
    getReady: '准备',
    prepareRead: '先看句子，倒计时后朗读',
    prepareAnswer: '先想回答，倒计时后开口',
    speakRead: '开口朗读',
    speakAnswer: '开口回答，不要念题目',
    listeningToYou: '在听你说',
    prepare: '{n} 秒后开始录音',
    recording: '正在录音 · 还剩 {n} 秒',
    done: '说完了',
    processing: '正在评分…',
    pronunciation: '发音',
    speed: '语速',
    content: '内容',
    wordsPerMinute: '{n} 词/分钟',
    cappedNote: '朗读发音分数限制了最终等级。',
    slowNote: '语速偏慢或长停顿较多，等级降了一级。',
    scoreFailed: '评分失败，请稍后重试。未完成的评分不扣额度。',
    recognitionFailed: '语音识别出错了，这次不算次数。请检查网络后重新开始。',
    retryTask: '语音服务刚才连接失败，已经换了线路，请把这一题再说一遍。',
    noSpeech: '没有识别到你的声音，这次不算次数。请检查麦克风后重新开始。',
    restart: '重新开始'
  },
  planLimit: {
    videoTitle: '这个视频 {minutes} 分钟，{plan}单个视频最长 {limit} 分钟',
    fileTitle: '这个文件 {minutes} 分钟，{plan}单个文件最长 {limit} 分钟',
    plans: { free: '免费版', pro: '专业版', premium: '高级版' },
    upgradeFrom: {
      free: '订阅专业版或购买任意额度包，可以导入 30 分钟以内的内容；高级版最长 60 分钟。',
      pro: '升级高级版，可以导入 60 分钟以内的内容。'
    },
    maxed: '请换一个更短的视频，或者剪成几段分别导入。',
    upgrade: '查看升级方案'
  },
  checkIn: {
    celebrationTitle: '今日打卡完成',
    celebrationMilestone: '达成连续 {streak} 天里程碑',
    celebrationStreak: '天连续打卡',
    celebrationReward: '+{amount} 额度已到账',
    celebrationFreezeUsed: '用掉 {count} 张冻结卡，连续记录保住了',
    celebrationFreezeEarned: '连续满 7 天，获得 1 张冻结卡',
    celebrationContinue: '继续练习',
    title: '学习打卡',
    subtitle: '查看你的学习时长记录',
    stats: {
      monthlyTotal: '本月总时长',
      activeDays: '本月天数',
      dailyAverage: '平均每日',
      days: '天'
    },
    loading: '加载中...',
    retry: '重试',
    timeFormat: {
      hours: '小时',
      minutes: '分',
      seconds: '秒'
    }
  },
  legal: {
    backToHome: '返回首页',
    termsLink: '服务条款',
    privacyLink: '隐私政策',
    refundLink: '退款政策',
    terms: {
      title: '服务条款',
      lastUpdated: '最后更新：2026年2月20日',
      acceptance: {
        title: '1. 接受条款',
        content: '访问或使用 GoodScriber（以下简称"服务"）即表示您同意受本服务条款的约束。如果您不同意这些条款，请不要使用本服务。'
      },
      description: {
        title: '2. 服务说明',
        content: 'GoodScriber 是一个基于 AI 的语言学习平台，专注于"跟读"（影子跟读法）学习方式。我们提供智能断句、带字幕音频播放、跟读练习等工具，同时支持音频转录和文字转语音功能来辅助您的学习。'
      },
      accounts: {
        title: '3. 用户账户',
        content: '使用本服务的某些功能需要创建账户。您可以通过邮箱或 Google 账号注册。您有责任维护账户凭据的保密性，并对账户下发生的所有活动负责。'
      },
      subscription: {
        title: '4. 付款',
        content: '部分功能需要 Pro 或 Premium 付费订阅。订阅按月或按年自动续费，直到您取消，并包含每月额度。您也可以一次性购买永久额度；有永久额度余额时享受 Pro 功能限制。价格变动将提前 30 天通知。所有付款通过 Stripe 安全处理。'
      },
      intellectualProperty: {
        title: '5. 知识产权',
        content: '本服务及其原始内容、功能和技术归 GoodScriber 所有，受国际版权、商标和其他知识产权法律保护。我们的 AI 模型和算法属于专有技术。'
      },
      userContent: {
        title: '6. 用户内容',
        content: '您上传到本服务的所有音频文件和文本内容的所有权归您所有。上传内容即表示您授予我们有限的许可，仅用于提供本服务。我们不会声称拥有您的内容所有权，也不会将其用于提供服务以外的目的。'
      },
      prohibited: {
        title: '7. 禁止行为',
        content: '您同意不将本服务用于任何非法目的，不上传侵犯第三方权利的内容，不试图未经授权访问本服务，不干扰或破坏本服务，也不使用本服务生成有害或误导性内容。'
      },
      limitation: {
        title: '8. 责任限制',
        content: '本服务按"现状"提供，不附带任何形式的保证。GoodScriber 不对因使用本服务而产生的任何间接、附带、特殊或后果性损害承担责任。我们的总责任不超过您在索赔前 12 个月内为本服务支付的金额。'
      },
      termination: {
        title: '9. 终止',
        content: '如果您违反本条款，我们可能随时终止或暂停您的账户。终止后，您使用本服务的权利将立即停止。您可以随时通过账户设置注销账户。'
      },
      changes: {
        title: '10. 条款变更',
        content: '我们保留随时修改本条款的权利。我们将通过电子邮件或服务内通知用户重大变更。变更后继续使用本服务即表示接受更新后的条款。'
      },
      contact: {
        title: '11. 联系我们',
        content: '如果您对本服务条款有任何疑问，请通过 {email} 联系我们。'
      }
    },
    privacy: {
      title: '隐私政策',
      lastUpdated: '最后更新：2026年2月20日',
      intro: {
        title: '1. 简介',
        content: 'GoodScriber（"我们"）致力于保护您的隐私。本隐私政策说明了我们在您使用服务时如何收集、使用和保护您的信息。'
      },
      collection: {
        title: '2. 我们收集的信息',
        content: '我们收集您直接提供的信息：通过 Google 或邮箱注册时的电子邮件地址和显示名称、您上传处理的音频文件和文本内容，以及通过 Stripe 安全处理的付款信息（我们不存储您的银行卡信息）。我们还自动收集使用数据（如使用的功能和会话时长）、设备信息（包括浏览器类型和操作系统）以及用于安全和分析的 IP 地址。'
      },
      usage: {
        title: '3. 我们如何使用您的信息',
        content: '我们使用您的信息来提供和维护服务、处理音频转录和文字转语音请求、处理付款、发送重要的服务相关通知、改进和优化服务，以及确保安全和防止欺诈。'
      },
      storage: {
        title: '4. 数据存储与安全',
        content: '您的数据使用 Google Firebase 和 Google Cloud 基础设施安全存储。音频文件存储在 Firebase Cloud Storage 中，通过签名 URL 安全访问。我们对传输中的数据（TLS/SSL）和静态数据实施行业标准加密。只要您的账户处于活跃状态，我们就会保留您上传的文件。您可以随时通过服务删除文件。'
      },
      thirdParty: {
        title: '5. 第三方服务',
        content: '我们使用以下第三方服务：Google Firebase 用于身份验证和数据存储，OpenAI Whisper 用于音频转录，OpenAI 和 Google Cloud 用于文字转语音，Stripe 用于支付处理，Google Analytics 用于使用分析。每个第三方服务都有其自己的隐私政策。'
      },
      cookies: {
        title: '6. Cookie 和本地存储',
        content: '我们使用浏览器本地存储来保存您的语言偏好和会话数据。我们使用 Cookie 进行身份验证状态管理。Google Analytics 可能会设置 Cookie 用于使用跟踪。您可以通过浏览器设置管理 Cookie 偏好。'
      },
      rights: {
        title: '7. 您的权利',
        content: '您有权通过账户设置访问、更新或删除您的个人信息，请求获取数据副本，退出营销通信，以及删除您的账户和相关数据。如需行使这些权利，请通过 {email} 联系我们。'
      },
      children: {
        title: '8. 儿童隐私',
        content: '本服务不面向 13 岁以下的用户。我们不会故意收集 13 岁以下儿童的个人信息。如果我们发现已收集此类信息，将立即删除。'
      },
      changes: {
        title: '9. 政策变更',
        content: '我们可能会不时更新本隐私政策。我们将通过在服务上发布新政策并更新"最后更新"日期来通知您任何重大变更。'
      },
      contact: {
        title: '10. 联系我们',
        content: '如果您对本隐私政策有任何疑问，请通过 {email} 联系我们。'
      }
    },
    refund: {
      title: '退款政策',
      lastUpdated: '最后更新：2026年2月20日',
      overview: {
        title: '1. 概述',
        content: '在 GoodScriber，我们希望您对购买感到满意。本退款政策说明了付费计划（Pro 和 Premium）可获得退款的条件。'
      },
      eligibility: {
        title: '2. 退款资格',
        content: '在购买后 7 天内，如果您使用的转录或文字转语音额度不超过 30 分钟，可申请全额退款。超过 7 天或大量使用额度后的退款请求将逐案评估。因技术问题导致无法使用服务的情况可能有资格获得按比例退款。'
      },
      process: {
        title: '3. 如何申请退款',
        content: '如需申请退款，请发送邮件至 {email}，提供您的账户邮箱、购买日期和退款原因。我们将在 3-5 个工作日内审核并回复您的请求。批准的退款将通过 Stripe 退回到原始支付方式，可能需要 5-10 个工作日才能显示在您的账单上。'
      },
      nonRefundable: {
        title: '4. 不予退款的情况',
        content: '以下情况通常不提供退款：超过 7 天期限、因违反服务条款而被终止的账户，以及已消耗的额度。'
      },
      cancellation: {
        title: '5. 取消订阅',
        content: '您可以随时通过 Stripe 账单门户取消订阅。取消后，套餐权限会保留到当前已付费周期结束，随后账户恢复为免费计划。已购买的永久额度继续保留且不会过期。您上传的文件和数据仍可访问。'
      },
      contact: {
        title: '6. 联系我们',
        content: '如需退款或有账单问题，请通过 {email} 联系我们。我们将尽快公平地处理所有退款咨询。'
      }
    }
  }
}

export default zh
